export default "__VITE_ASSET__DlNbqjeU__"